import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.33333 2V4.66667M2 3.33333H4.66667M4 11.3333V14M2.66667 12.6667H5.33333M8.66667 2L10.1905 6.57143L14 8L10.1905 9.42857L8.66667 14L7.14286 9.42857L3.33333 8L7.14286 6.57143L8.66667 2Z" />
  </svg>
);
